import { useWebsiteSettings } from 'client/store'
import { WebsiteSettingsTypographyTypeEnum } from 'src/shared/types/website-settings-types'
import { typographySelectorMap } from 'src/editor/store/website-settings/website-settings-selector'
import { getCalculatedProperty } from 'src/shared/utils/get-calculated-property'

export const useCalculateLetterSpacing = ({
  letterSpacing,
  mobileLetterSpacing,
  typographyType = WebsiteSettingsTypographyTypeEnum.Paragraph,
}: {
  letterSpacing?: number
  mobileLetterSpacing?: number
  typographyType?: WebsiteSettingsTypographyTypeEnum
}) => {
  // NOTE: Should we add global letter spacing for funnel settings?
  const typographySelector = typographySelectorMap[typographyType]

  const {
    letterSpacing: websiteGlobalLetterSpacing,
    mobileLetterSpacing: websiteGlobalMobileLetterSpacing,
  } = useWebsiteSettings(typographySelector) || {}

  return {
    calculatedLetterSpacing: getCalculatedProperty({
      desktopProperty: letterSpacing,
      mobileProperty: mobileLetterSpacing,
      globalDesktopProperty: websiteGlobalLetterSpacing,
      globalMobileProperty: websiteGlobalMobileLetterSpacing,
    }),
    globalLetterSpacing: websiteGlobalLetterSpacing,
    globalMobileLetterSpacing: websiteGlobalMobileLetterSpacing,
  }
}
